import { useDispatch } from "react-redux"
import { useAuthState } from "../../../../../../Helper/Context"
import { SocialMediaAndOfficerVisit } from "./SocialMediaAndOfficerVisit/SocialMediaAndOfficerVisit"
import { ViewVehicleScheduling } from "./ViewVehicleScheduling/ViewVehicleScheduling"
import { ReceivedComplaintsFromOfficials } from "./ReceivedComplaintsFromOfficials/ReceivedComplaintsFromOfficials"
import { ViewScheduling } from "./ViewScheduling/ViewScheduling"
import { Footer } from "../../../Footer"

export const EnchrochmentDashboardComponents = (props) => {

    const { DataObj, IsDashPost, setIsDashPost } = props

    const {
        Countdata,
        isCountLoading,
        PlanationDetailsCountdata,
        YearValue,
        MonthValue,
        ZoneValue,
        DashSelect,
        Language,

    } = DataObj


    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, UserFullName, RoleID } = userDetails

    return (
        <>
            <SocialMediaAndOfficerVisit
                DataObj={DataObj} />

            <ViewVehicleScheduling
                DataObj={DataObj} />

            <ReceivedComplaintsFromOfficials
                DataObj={DataObj} />

            <ViewScheduling
                DataObj={DataObj}
                RoleID={RoleID}
                IsDashPost={IsDashPost}
                setIsDashPost={setIsDashPost} />

            <Footer />

        </>
    )
}